var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Translate } from "../../../../../I18N";
import { Button, EmbededButton, Pill } from "../../../../Components/UI";

import ChevronUpIcon from '@heroicons/react/20/solid/ChevronUpIcon';
import ChevronDownIcon from '@heroicons/react/20/solid/ChevronDownIcon';


const TemplateHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Templates");

const ThesaurusLabel = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex items-center " }, void 0, /*#__PURE__*/
_jsx("span", { className: "text-indigo-700" }, void 0, cell.row.original.name), "\xA0",

'(', /*#__PURE__*/
_jsx(Translate, { context: cell.row.original._id }, void 0, cell.row.original.name),
')'
);


const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const ThesaurusValueLabel = ({ row, getValue }) => /*#__PURE__*/
_jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
_jsx(Translate, {
  context: "Menu",
  className: row.getIsExpanded() ? 'text-indigo-700' : 'text-indigo-700' }, void 0,

getValue()
),
row.getCanExpand() && /*#__PURE__*/
_jsx(EmbededButton, {
  icon: row.getIsExpanded() ? /*#__PURE__*/_jsx(ChevronUpIcon, {}) : /*#__PURE__*/_jsx(ChevronDownIcon, {}),
  onClick: () => row.toggleExpanded(),
  color: "indigo",
  className: "bg-indigo-200 border-none rounded-md drop-shadow-none" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Group")
)

);


const templatesCells = ({ cell }) => {var _cell$getValue;return /*#__PURE__*/(
    _jsx("div", { className: "flex flex-wrap gap-2" }, void 0, (_cell$getValue =
    cell.getValue()) === null || _cell$getValue === void 0 ? void 0 : _cell$getValue.map((template) => /*#__PURE__*/
    _jsx("div", {}, cell.id + template._id, /*#__PURE__*/
    _jsx(Pill, { color: "gray", className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: template._id }, void 0, template.name)
    )
    )
    )
    ));};


const EditButton = ({ cell, column }) => /*#__PURE__*/
_jsx(Button, {
  styling: "action",
  onClick: () => {var _column$columnDef$met, _column$columnDef$met2;return (_column$columnDef$met = column.columnDef.meta) === null || _column$columnDef$met === void 0 ? void 0 : (_column$columnDef$met2 = _column$columnDef$met.action) === null || _column$columnDef$met2 === void 0 ? void 0 : _column$columnDef$met2.call(_column$columnDef$met, cell.row);},
  className: "leading-4" }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, "Edit")
);


const LabelHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Label");










const columnHelper = createColumnHelper();
const columns = (actions) => [
columnHelper.accessor('label', {
  id: 'label',
  header: LabelHeader,
  cell: ThesaurusValueLabel,
  meta: { headerClassName: 'w-11/12' }
}),
columnHelper.accessor('_id', {
  header: ActionHeader,
  cell: EditButton,
  enableSorting: false,
  meta: {
    action: actions.edit,
    headerClassName: 'text-center w-0 sr-only'
  }
})];


export {
  ThesaurusLabel,
  LabelHeader,
  EditButton,
  ThesaurusValueLabel,
  ActionHeader,
  templatesCells,
  TemplateHeader,
  columns };